module.exports = __webpack_public_path__ + "assets/images/home/background-tablet.2741a4e67a58154f6655f94c7aa3d1e0.webp";